module.exports = __webpack_public_path__ + "img/sepa.5609b15.svg";